module.exports = "build/assets/leftWhispWhiteBg.f55cc90f.png";